import { ComponentChildren, h } from "preact";
import { Icon, ToolIcon } from "uitoolkit";
import "./datatable.scss";

// https://mui.com/material-ui/react-table/
// https://preview.colorlib.com/theme/bootstrap/css-table-11/
// https://www.material-ui-datatables.com/
// https://mui.com/core/
// https://css-tricks.com/how-to-recreate-the-ripple-effect-of-material-design-buttons/

interface Props {
    showHeader?: boolean;
    columns: { name: string }[];
    items: (any[])[];
    selectable?: boolean | undefined;
}

export function DataTable(props: Props) {
    return (
        <table className="material-datatable sticky">
            {
                (props.showHeader !== false) &&
                <thead>
                    <tr>
                        {
                            props.selectable && (
                                <th className="short"></th>
                            )
                        }
                        {
                            props.columns.map(item => (
                                <th>
                                    {item.name}
                                </th>
                            ))
                        }
                    </tr>
                </thead>
            }
            <tbody>
                {
                    props.items.map(item => (
                        <tr>
                            {
                                props.selectable && (
                                    <td><input type="checkbox" /> </td>
                                )
                            }
                            {
                                props.columns.map((column, index) => (
                                    <td>
                                        {
                                            item[index]
                                        }

                                    </td>
                                ))
                            }
                        </tr>
                    ))
                }
            </tbody>
        </table>
    );
}


export interface TypedTableColummn<T> {
    name: string;
    key?: keyof T;
    getter?: (item: T, itemIndex: number, column: TypedTableColummn<T>, columnIndex: number) => ComponentChildren;
    getSortingKey?: (item: T) => string;
}

interface TypedProps<TItem, TKey> {
    columns: TypedTableColummn<TItem>[];
    items: TItem[];
    sticky?: boolean;
    className?: string;
    showHover?: boolean;
    showHeader?: boolean;
    sortColumn?: string;
    sortOrder?: "ascending" | "descending";
    onColumnClicked?: (column: TypedTableColummn<TItem>) => void;
    selectable?: boolean;
    actionItemIcon?: string;
    onItemAction?: (item: TItem) => void;
    onItemSelected?: (item: TItem, selected: boolean, index: number) => void;
    onItemClicked?: (item: TItem) => void;
    getItemKey: (item: TItem) => TKey;
    getItemClass?: (item: TItem) => string | undefined;
    selectedIds?: TKey[];
}

// todo: support for hover on rows that only changes the edges
// todo: support for rows with custom background color

export function DataTableTyped<TItem, TKey extends string | number>(props: TypedProps<TItem, TKey>) {
    const showHover = props.showHover !== false;
    const showHeader = props.showHeader !== false;
    const sticky = showHeader && props.sticky !== false;
    const enableSelection = !!props.selectable && !!props.getItemKey && !!props.onItemSelected && !!props.selectedIds;

    // todo: memoize the callbacks for each row and column
    return (
        <table className={"material-datatable" + (props.selectable ? " selectable" : "") + (showHover ? "" : " nohover") + (sticky ? " sticky" : "") + (showHeader ? " header" : "") + (!!props.className ? (" " + props.className) : "")}>
            {
                showHeader &&
                <thead>
                    <tr>
                        {
                            props.selectable && (
                                <th className="short"><span>&nbsp;</span></th>
                            )
                        }
                        {
                            props.columns.map(item => (
                                <th onClick={() => props.onColumnClicked && props.onColumnClicked(item)}>
                                    <span>
                                        {item.name}
                                        {
                                            props.sortColumn == item.name &&
                                            <Icon icon={props.sortOrder == "descending" ? "sort-descending" : "sort-ascending"} />
                                        }
                                    </span>
                                </th>
                            ))
                        }
                        {
                            props.onItemAction && (
                                <th className="short"><span>&nbsp;</span></th>
                            )
                        }
                    </tr>
                </thead>
            }
            <tbody>
                {
                    props.items.map((item, itemIndex) => (
                        <tr data-id={props.getItemKey(item)}
                            onClick={(e) => {
                                props.onItemClicked?.(item);
                                enableSelection && props.onItemSelected?.(item, props.selectedIds ? !props.selectedIds.includes(props.getItemKey(item)) : true, itemIndex);
                            }}
                            className={props.getItemClass?.(item)}
                        >
                            {
                                props.selectable && (
                                    <td><input type="checkbox" checked={enableSelection && props.selectedIds?.includes(props.getItemKey(item))} onClick={e => {
                                        props.onItemSelected?.(item, e.currentTarget.checked, itemIndex);
                                        e.stopPropagation();
                                    }} /> </td>
                                )
                            }
                            {
                                props.columns.map((column, columnIndex) => (
                                    <td>
                                        {
                                            column.getter
                                                ? column.getter(item, itemIndex, column, columnIndex)
                                                : column.key
                                                    ? ("" + (item[column.key] == null ? "" : item[column.key]))
                                                    : ""
                                        }
                                    </td>
                                ))
                            }
                            {
                                props.onItemAction &&
                                <td class="action">
                                    <ToolIcon icon={props.actionItemIcon ?? "menu_open"} onClick={e => {
                                        e.stopPropagation();
                                        props.onItemAction?.(item);
                                    }} />
                                </td>
                            }
                        </tr>
                    ))
                }
            </tbody>
        </table>
    );
}
